export default "__VITE_ASSET__DW0M41x7__"